module.exports = __webpack_public_path__ + "static/media/other-hooman.0010d21c.png";